/**
 * AccountChoiceScreen — « Ajouter un compte » (`account-choice`), sur le design system.
 *
 * Portage de `src/auth/AccountChoiceScreen.js` (« Choisir une option ») : la page est contrôlée, ses
 * gestes viennent de `useAccountChoiceState`.
 */
import { AccountChoicePage } from "../../../../../../design-system"
import { AuthStatusBar } from "../AuthStatusBar"
import { useAccountChoiceState } from "./useAccountChoiceState"

export function AccountChoiceScreen() {
    const page = useAccountChoiceState()
    return (
        <>
            <AccountChoicePage {...page} />
            <AuthStatusBar />
        </>
    )
}

export default AccountChoiceScreen
